import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

const UploadLogIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    fill="none"
    height="14"
    viewBox="0 0 13 14"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10.4973 9.62286C10.4973 9.15779 10.8803 8.74744 11.3727 8.74744C11.8378 8.74744 12.2482 9.15779 12.2482 9.62286V11.3737C12.2482 12.851 11.0718 14 9.62189 14H2.61847C1.14119 14 -0.0078125 12.851 -0.0078125 11.3737V9.62286C-0.0078125 9.15779 0.375187 8.74744 0.867615 8.74744C1.33269 8.74744 1.74304 9.15779 1.74304 9.62286V11.3737C1.74304 11.8661 2.12604 12.2491 2.61847 12.2491H9.62189C10.087 12.2491 10.4973 11.8661 10.4973 11.3737V9.62286ZM5.49097 0.266732C5.81925 -0.0889106 6.39375 -0.0889106 6.72204 0.266732L10.2237 3.76844C10.5794 4.09673 10.5794 4.67123 10.2237 4.99951C9.89546 5.35515 9.32096 5.35515 8.99268 4.99951L6.99561 3.00244V8.74744C6.99561 9.23986 6.58525 9.62286 6.12018 9.62286C5.62775 9.62286 5.24475 9.23986 5.24475 8.74744V3.00244L3.22033 4.99951C2.89204 5.35515 2.31754 5.35515 1.98926 4.99951C1.63361 4.67123 1.63361 4.09673 1.98926 3.76844L5.49097 0.266732Z" />
  </SvgIcon>
);

export default UploadLogIcon;
